// lifelink/src/components/auth/ProtectedRoute.js

import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

/**
 * ProtectedRoute Component
 * -------------------------
 * This component acts as a gatekeeper for private/protected routes.
 * It checks if the user is authenticated. If not, it redirects them to the login page.
 * It also stores the route the user attempted to visit so they can be redirected back after successful login.
 */
const ProtectedRoute = ({ element }) => {
  const { user } = useAuth(); // Get the current authenticated user from context
  const location = useLocation(); // Access the current route information

  // Store the current route (including search/query params) in localStorage.
  // This ensures the user is redirected back here after logging in.
  localStorage.setItem("redirectAfterLogin", location.pathname + location.search);

  // If the user is not logged in, redirect them to the login page
  if (!user) {
    // Redundant but ensures the last visited route is captured before redirection
    localStorage.setItem("redirectAfterLogin", location.pathname + location.search);
    return <Navigate to="/login" />; // Redirect to login page
  }

  // If user is authenticated, allow access to the requested route (render the component)
  return element;
};

export default ProtectedRoute;
